export default __webpack_public_path__ + "static/media/TapersImg.9ba62b12.jpg";